import { FC, ReactNode } from "react";
import InnerPage from "../../shared/components/InnerPage";
import Icon, { IconName } from "../../shared/components/Icon";
import { PATHS } from "../../paths";

export interface ServiceSection {
  icon: IconName;
  title: string;
  paragraphs: ReactNode[];
}

interface ServicePageProps {
  title: string;
  seoDescription: string;
  intro: ReactNode[];
  sections: ServiceSection[];
  image?: { src: string; alt: string };
}

const ServicePage: FC<ServicePageProps> = ({
  title,
  seoDescription,
  intro,
  sections,
  image,
}) => (
  <InnerPage
    eyebrow="Hizmetlerimiz"
    title={title}
    crumbs={[{ label: "Hizmetlerimiz", to: PATHS.fire }, { label: title }]}
    seoDescription={seoDescription}
    withSidebar
  >
    <div className="it-prose">
      <h2>{title}</h2>
      {intro.map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}
      {sections.map((section) => (
        <div key={section.title}>
          <h3>
            <Icon name={section.icon} />
            {section.title}
          </h3>
          {section.paragraphs.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
      ))}
      {image && (
        <div className="it-photo it-photo--land" style={{ marginTop: 30 }}>
          <img src={image.src} alt={image.alt} />
        </div>
      )}
    </div>
  </InnerPage>
);

export default ServicePage;
